import React from 'react';
import {View, Text} from 'native-base';
import {useTheme} from 'styled-components/native';
import {formatNumber} from '@eCommerce/frontend-legacy-shared-library-native';

export interface CurrentTierCreditsProps {
  tierCredits: number;
}

const CurrentTierCredits: React.FC<CurrentTierCreditsProps> = ({
  tierCredits,
}) => {
  const theme = useTheme();
  const {shuttleGray, paleSky, tuna} = theme.colors;

  return (
    <View flexDirection={'row'}>
      <Text
        fontFamily={'body'}
        fontSize={'11px'}
        fontWeight="bold"
        color={shuttleGray}>
        {formatNumber(tierCredits)}
      </Text>
      <Text
        fontFamily="body"
        fontSize={'11px'}
        color={shuttleGray}
        marginLeft="4px">
        Tier Credits
      </Text>
    </View>
  );
};

export default CurrentTierCredits;
